var version = {
    "name":      "dativery",
    "buildDateCode": "20260410-095425",
    "buildDate": "Fri Apr 10 2026 09:54:25 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260410-095425",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;